
function DNDImage({card, language, elementStyle, changeSelection, imgWidth = '7'}) {

    return (
      <div
        id="componentContainer"
        data-tour="rpdesigner-step-3"
        style={elementStyle}
        onClick={changeSelection}
      >
        {card?.value[1]?.languages[language] ? (
          <a
            hrefx={card?.value[1]?.languages[language]}
            target="_blank"
            rel="noreferrer"
            style={{ width: "100%" }}
          >
            <img
              alt="source not found"
              src={card?.value[0].languages[language]}
              style={{
                width: imgWidth + "%",
                objectFit: "contain",
              }}
            />
          </a>
        ) : (
          <img
            alt="source not found"
            src={card?.value[0].languages[language]}
            style={{
              width: imgWidth + "%",
              objectFit: "contain",
            }}
          />
        )}

        <input
          readOnly
          id="displayDefault"
          style={{ display: "none" }}
          value={card.displayDefault}
        />
        <input
          readOnly
          id="displaySuccess"
          style={{ display: "none" }}
          value={card.displaySuccess}
        />
        <input
          readOnly
          id="displayError"
          style={{ display: "none" }}
          value={card.displayError}
        />
      </div>
    );
}

export default DNDImage;